var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHeader),expression:"showHeader"}],class:_vm.$style.header},[_vm._v(" "+_vm._s(_vm.headerLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }